export {
  GiftCardOrderPage as default,
  GiftCardOrderPageStaticProps as getStaticProps,
} from "@chef/feature-my-account";
